module.exports = {
  countryCode: '44',
  locale: 'en_GB',
}
